export default __webpack_public_path__ + "static/media/right_top.04afd741.png";